import Navigo from 'navigo';
const BASE_PATH = '/';
let _routerConfigInstance;
export class Router {
    constructor(routes, template) {
        this.routes = routes;
        this.template = template;
        this.listenFunctions = [];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        _routerConfigInstance = this;
        this.navigoRouter = new Navigo(BASE_PATH, { strategy: 'ONE' });
        this.setupHooks();
    }
    static getInstance() {
        return _routerConfigInstance;
    }
    configRouter() {
        for (const route of this.routes) {
            this.navigoRouter.on(route.path, () => {
                setTimeout(() => {
                    if (route.render) {
                        this.template.unmountCurrentMicrofrontend();
                        route.render(this.template.getRootElement());
                        return;
                    }
                    this.template.render(route.microfrontend);
                }, 0);
            });
        }
    }
    start() {
        this.navigoRouter.resolve();
    }
    getCurrentRouteLocation() {
        const { url, queryString, params } = this.navigoRouter.getCurrentLocation();
        return {
            url,
            queryString,
            params,
        };
    }
    navigate(path) {
        if (this.navigoRouter.getCurrentLocation().url === path.replace('/', '')) {
            return;
        }
        this.navigoRouter.navigate(path);
    }
    listen(fn) {
        this.listenFunctions.push(fn);
    }
    removeListen(fn) {
        this.listenFunctions.splice(this.listenFunctions.indexOf(fn), 1);
    }
    setupHooks() {
        this.navigoRouter.hooks({
            after: (match) => {
                this.listenFunctions.forEach((fn) => fn(match));
            },
        });
    }
}
